// removed by extract-text-webpack-plugin
module.exports = {"visiblyHidden":"nrk-v17-static-visiblyHidden"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/stylesheets/utils.css
// module id = 248
// module chunks = 0 1 2 3 4 5